<template>
    <v-card flat class="cardBorderStyle d-flex align-center justify-center">
        <div id="chart-container"></div>
    </v-card>
</template>

<script>
import * as d3 from 'd3';
import moment from 'moment';
import { mapGetters } from 'vuex';
export default {
    name: 'todayBarChart',
    props: {
        userSessionList: Array,
    },
    computed: {
        ...mapGetters(['kioskAnalytics', 'todayBarChart', 'kioskAnalyticsDimension', 'windowSize'])
    },
    watch: {
//         userSessionList(newVal) {
//     console.log('🔍 userSessionList updated:', newVal);

//     // You can also check if it's empty or undefined
//     if (!newVal || newVal.length === 0) {
//       console.warn('⚠️ No user sessions available');
//       return;
//     }

//     // Once verified, you can trigger your update or chart render
//     // this.createBarChart();
//   },
        kioskAnalytics(newVal) {
            this.createBarChart();
        },
        windowSize(newVal) {
            this.createBarChart();
        }
    },
    data() {
        return {
            //
        };
    },
    mounted() {
        //this.createBarChart();
    },
    methods: {
        createBarChart() {
    d3.select('#chart-container').selectAll('*').remove();

    // STEP 1: Aggregate sessions by hour of start time
    const sessionsByHour = d3.rollup(
      this.userSessionList,
      v => v.length,
      d => moment(d.userSessionStartTime).hour()
    );

    // Define the hour range (8 AM to 5 PM for example)
    const hours = d3.range(8, 18); // 8 to 17
    const todayBarChart = hours.map(hour => ({
      category: moment().hour(hour).format('h A'),
      value: sessionsByHour.get(hour) || 0,
    }));

    // STEP 2: Build the chart (your existing logic)
    const width = this.kioskAnalyticsDimension.reportBarChartDimension.width;
    const height = this.kioskAnalyticsDimension.reportBarChartDimension.height;
    const margin = { top: 20, right: 20, bottom: 50, left: 55 };

    const svg = d3.select('#chart-container')
      .append('svg')
      .attr('width', width)
      .attr('height', height);

    const xScale = d3.scaleBand()
      .domain(todayBarChart.map(d => d.category))
      .range([margin.left, width - margin.right])
      .padding(0.5);

    const yScale = d3.scaleLinear()
      .domain([0, d3.max(todayBarChart, d => d.value)])
      .nice()
      .range([height - margin.bottom, margin.top]);

    svg.append('g')
      .attr('class', 'x-axis')
      .attr('transform', `translate(0,${height - margin.bottom})`)
      .call(d3.axisBottom(xScale));

    svg.append('text')
      .attr('x', width / 2)
      .attr('y', height - margin.bottom + 40)
      .attr('text-anchor', 'middle')
      .style('font-size', '10px')
      .text('Hours');

    svg.append('g')
      .attr('class', 'y-axis')
      .attr('transform', `translate(${margin.left},0)`)
      .call(d3.axisLeft(yScale));

    svg.append('text')
      .attr('transform', 'rotate(-90)')
      .attr('x', -height / 2)
      .attr('y', margin.left - 40)
      .attr('text-anchor', 'middle')
      .style('font-size', '10px')
      .text('User Sessions');

    // STEP 3: Bars
    if (todayBarChart.every(item => item.value === 0)) {
      svg.append('text')
        .attr('x', width / 2)
        .attr('y', height / 2)
        .attr('text-anchor', 'middle')
        .text('No Data Available');
    } else {
      svg.selectAll('rect')
        .data(todayBarChart)
        .enter()
        .append('rect')
        .attr('x', d => xScale(d.category))
        .attr('y', d => yScale(d.value))
        .attr('width', xScale.bandwidth())
        .attr('height', d => height - margin.bottom - yScale(d.value))
        .attr('fill', '#0d3b66');

      svg.selectAll('.bar-label')
        .data(todayBarChart)
        .enter()
        .append('text')
        .text(d => (d.value !== 0 ? d.value : ''))
        .attr('x', d => xScale(d.category) + xScale.bandwidth() / 2)
        .attr('y', d => yScale(d.value) - 5)
        .attr('text-anchor', 'middle')
        .attr('class', 'bar-label');
    }
  }
    },
};
</script>

<style>
.cardBorderStyle {
    border-right: solid 1px #111111 !important;
    border-radius: 0px !important;
}
</style>